import Vue from "vue";
import Vuetify from "vuetify/lib";
import es from "vuetify/es5/locale/es";
import { loadThemeDark } from '@/utils/themePreference';
Vue.use(Vuetify);

/*
 * Paleta del shell (barra, menú, fondo, footer), junto a los colores de marca.
 * Con `customProperties` Vuetify publica cada clave como `--v-<clave>-base` y
 * la vuelve a publicar al cambiar de tema; `main.css` solo las lee (`--app-*`).
 * Para retocar un color de la interfaz se cambia AQUÍ, no en el CSS.
 *
 *   appbar    barra superior (verde de la marca; el rojo del logo no se usa de
 *             cromo porque en la interfaz el rojo significa error)
 *   onbar     texto e iconos sobre la barra
 *   canvas    fondo detrás de las pantallas (crema de paja)
 *   navbg     menú lateral y footer (verde salvia suave)
 *   surface   tarjetas, tablas y diálogos
 *   sunken    campos y zonas hundidas
 *   onsurface tinta; de ella salen texto, líneas y hover con transparencia
 *
 * Modo oscuro: opt-in desde el menú de la cuenta (AppBar), se recuerda en el
 * navegador (`utils/themePreference.js`) y arranca en claro. El tema `dark`
 * redefine las mismas claves; el primario baja a un teal medio para que sirva
 * a la vez de fondo con texto blanco y de texto sobre fondo oscuro. Ver
 * DESIGN.md > Color > Modo oscuro para lo que aún falta revisar.
 */
export default new Vuetify({
  theme: {
    dark: loadThemeDark(),
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#00695C",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        appbar: "#00695C",
        onbar: "#FFFFFF",
        canvas: "#F6F4EE",
        navbg: "#E3EAE4",
        surface: "#FFFFFF",
        sunken: "#F6F7F7",
        onsurface: "#000000"
      },
      dark: {
        primary: "#00897B",
        secondary: "#9E9E9E",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        appbar: "#0F3D36",
        onbar: "#FFFFFF",
        canvas: "#121614",
        navbg: "#1A211D",
        surface: "#1E1E1E",
        sunken: "#181818",
        onsurface: "#FFFFFF"
      },
    }
  },
  lang: {
    // Textos de las tablas: "Filas por página", "1–25 de 83" y el vacío general.
    locales: {
      es: {
        ...es,
        noDataText: 'No hay registros que mostrar',
        dataFooter: { ...es.dataFooter, itemsPerPageText: 'Filas por página:', pageText: '{0}–{1} de {2}' }
      }
    },
    current: "es"
  },
  icons: {
    iconfont: "fa"
  }
});
